import { Button } from "ui/components/Button/Button";
import { transformRoute } from "helpers";
import { ContactRepresentativeHeaderProps } from "./types";
import { ButtonLink } from "ui/components/Button/ButtonLink";
import { Routes as ContactRoutes } from "ui/modules/contacts/navigation";

const ContactRepresentativeHeader = ({ contactDetail, onAdd }: ContactRepresentativeHeaderProps) => {
    if (!contactDetail.id || contactDetail.contactType?.id !== "C") return <></>;

    return (
        <div className="flex gap-2">
            <ButtonLink
                size="small"
                variant="warning"
                children="Pregled"
                to={transformRoute(
                    ContactRoutes.ContactRepresentativeSearchPageRouter,
                    {
                        id: contactDetail.id,
                    }
                )}
                startIcon="/media/icons/search.svg"
            />
            <Button
                size="small"
                variant="secondary"
                children="Kreiraj"
                onClick={onAdd}
                startIcon="/media/icons/plus.svg"
            />
        </div>
    );
};

export default ContactRepresentativeHeader;
